<template>
  <asc-page-loading-indicator
    :loading="isAlertLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-custom-alerts-alert-container">
      <asc-sticky :is-sticky="isSticky">
        <v-row :class="{ isSticky: isSticky }" no-gutters class="sticky-header">
          <v-col>
            <asc-page-header>
              <template #pageTitle>
                <asc-custom-alerts-title-wrapper
                  :alert-type="alertType"
                  :is-advanced-full-flight="isAdvancedFullFlight"
                  :is-advanced-dplf="isAdvancedDplf"
                  :is-sticky="isSticky"
                ></asc-custom-alerts-title-wrapper>
              </template>
              <template #pageActions>
                <asc-custom-alerts-header-wrapper
                  :alert-type="alertType"
                  :is-sticky="isSticky"
                  :is-dirty="isDirty"
                  :alert-id="alertId"
                  :save-disabled="saveDisabled"
                  :activate-enabled="getActivateEnabled"
                  :active="getIsActive"
                  :save-loading="saveLoading"
                  :full-flight-active-count="getFullFlightActiveCount"
                  :is-tails-alert-active="isTailAlertActive"
                  :is-flight-phase-alert-active="isFlightPhaseAlertActive"
                  :is-threshold-alert-active="isThresholdAlertActive"
                  :is-data-bricks-running="isDataBricksRunning"
                  :is-read-only="getIsReadOnly"
                  @handleSave="handleSave"
                  @handleCancel="handleLaunchCancelDialog"
                  @handleToggleActivate="handleToggleActivate"
                ></asc-custom-alerts-header-wrapper>
              </template>
            </asc-page-header>
          </v-col>
        </v-row>
      </asc-sticky>
      <asc-custom-alerts-notifications-wrapper
        :is-tail-notification-active="isTailNotificationActive"
        :is-flight-phase-notification-active="isFlightPhaseNotificationActive"
        :is-threshold-notification-active="isThresholdNotificationActive"
        :is-ata-chapter-notification-active="isAtaChapterNotificationActive"
        :is-report-persistence-notification-active="
          isReportPersistenceNotificationActive
        "
        :is-days-persistence-notification-active="
          isDaysPersistenceNotificationActive
        "
        :is-flights-persistence-notification-active="
          isFlightsPersistenceNotificationActive
        "
        :is-recommended-action-notification-active="
          isRecommendedActionNotificationActive
        "
        :is-logic-builder-notification-active="showLogicValidationErrorMessage"
        :logic-string-error-message="logicStringValidationErrorText"
      />
      <template slot="subheader">
        <asc-surface-support-text
          :text="getSurfaceSupportText"
        ></asc-surface-support-text>
        <asc-surface-support-text
          :text="getWarningSupportText"
        ></asc-surface-support-text>
      </template>
      <asc-custom-alerts-alert-template
        :alert-data="customAlert"
        :user="profile"
        :selected-airline-name="selectedAirlineName"
        :alert-type="alertType"
        :airline="airline"
        :airline-id="airlineId"
        :platform="platform"
        :report-type="reportType"
        :activate-enabled="activateEnabled"
        :user-airlines="mappedUserAirlines"
        :show-configuration="showConfiguration"
        :show-add-parameter="showAddParameter"
        :parameter-name="selectedParameterName"
        :histogram-unit-name="selectedParameterUnit"
        :save-loading="saveLoading"
        :flight-phases="isAdvancedAcmf ? [] : mappedFlightPhases"
        :is-histogram-data-loading="isHistogramDataLoading"
        :parameter-tail-list="parameterTailList"
        :part-numbers="partNumbers"
        :ata-chapter-list="mappedLuAtaChapters"
        :message-codes="messageCodes"
        :parameter-list="getAllParameterList"
        :advanced-function-list="customAlertFunctionList"
        :full-flight-active-count="getFullFlightActiveCount"
        :pdf-guide="logicBuilderGuide"
        :logic-string-valid="logicStringValid"
        :expression="logicExpression"
        :validate-loading="validateLoading"
        :allowed-characters="getAllowedCharacterExpInputs"
        :expression-options="getExpressionOptions"
        :is-advanced-full-flight="isAdvancedFullFlight"
        :is-advanced-dplf="isAdvancedDplf"
        :is-shared-disabled="hasDerivedParameter"
        :airlines-tier-type="getAirlinePlatformTierType"
        :is-look-back-valid="isLookBackValid"
        :is-threshold-alert-active="isThresholdAlertActive"
        :is-valid-rec-action="isRecommendedActionAlertActive"
        :show-logic-validation-error-message="showLogicValidationErrorMessage"
        :logic-string-validation-error-text="logicStringValidationErrorText"
        :is-ata-error-displayed="isAtaChapterAlertActive"
        :is-data-bricks-running="isDataBricksRunning"
        :enable-run-performance-estimate="enableRunPerformanceEstimate"
        :enable-validate-button="enableValidateBtn"
        :estimate-button-name="getPerformanceAnalysisName"
        :look-back-response="dataBricksTriggerResponse"
        :tooltip-msg="tooltipMsg"
        :display-run-performance-section="displayRunPerformanceSection"
        :is-read-only="getIsReadOnly"
        :run-limit="getRunLimit"
        @updateThresholdAlertStatus="evaluateThresholdAlert"
        @handleAddParameter="handleLaunchAddParameterDialog"
        @handleRemoveParameter="handleLaunchRemoveParameterDialog"
        @handleSaveAlert="handleSaveAlert"
        @handleCancelAlert="handleLaunchCancelDialog"
        @handleUpdateAlertName="handleUpdateAlertName"
        @onUpdateAlertDescription="handleUpdateAlertDescription"
        @handleChangeTails="handleChangeTails"
        @handleChangeRecAction="handleChangeRecAction"
        @isDirty="handleChangeIsDirty"
        @isShared="handleChangeIsShared"
        @handleChangeAtaChapters="handleChangeAtaChapters"
        @handleChangePersistenceFrom="handleChangePersistenceFrom"
        @handleChangePersistenceTo="handleChangePersistenceTo"
        @handleChangeAggregateDays="handleChangeAggregateDays"
        @handleChangeAggregateReports="handleChangeAggregateReports"
        @handleChangeConfigurationType="handleChangeConfigurationType"
        @handleUpdateHighCaution="handleUpdateHighCaution"
        @handleUpdateLowCaution="handleUpdateLowCaution"
        @handleUpdateLowWarning="handleUpdateLowWarning"
        @handleUpdateHighWarning="handleUpdateHighWarning"
        @handleUpdateMinRange="handleUpdateMinRange"
        @handleUpdateMaxRange="handleUpdateMaxRange"
        @handleUpdateFlightPhase="handleUpdateFlightPhase"
        @handleChangeFlightPhase="evaluateFlightPhaseAlert"
        @handleToggleActivate="handleToggleActivate"
        @handleDuplicateAlert="handleDuplicateAlert"
        @handleClearHistogramData="handleClearHistogramData"
        @isSaveDisabled="handleChangeSaveDisabled"
        @handleChangeActivateEnabled="handleChangeActivateEnabled"
        @handleChangeSeverityLevel="handleChangeSeverityLevel"
        @handleLogicValidate="handleLogicValidate"
        @handleTextUpdated="handleTextUpdated"
        @handleChangePartNumbers="handleChangePartNumbers"
        @onPerformanceAnanlysis="handlePerformanceAnanlysis"
        @onCancelPerformanceAnalysis="handleCancelPerformanceAnalysis"
        @handleChangeResetPerformanceValues="handleChangeResetPerformanceValues"
        @onSeeEstimateDash="handleSeeEstimateDash"
        @onDatabricksErrorNotificationClose="
          handleDatabricksErrorNotificationClose
        "
      ></asc-custom-alerts-alert-template>
      <asc-custom-alerts-add-parameter-dialog
        :show-dialog="showParameterDialog"
        :on-close="handleCloseParameterDialog"
        :column-defs="getFilteredParameterColumnDefs"
        :parameters="parameterList"
        :airlines="getUserAirlines"
        :report-types="reportTypesData"
        :alert-type="alertType"
        :loading="isParameterListLoading"
        :on-apply="handleAddParameterToCustomAlert"
        @airlineReportSelected="getSnapshotParameterListForModal"
        @setSnapshotAirlineId="handleUpdateSnapshotAlertAirline"
        @setSnapshotReportType="handleUpdateSnapshotAlertReportType"
      ></asc-custom-alerts-add-parameter-dialog>
      <asc-dialog
        :show-dialog="showParameterRemovalConfirmationDialog"
        :text="getParameterRemovalDialogTitle"
        :on-primary="handleConfirmRemoveParameter"
        :on-secondary="cancelRemoveParameter"
        secondary-button-text="Cancel"
        primary-button-text="Remove Parameter"
      >
        {{ getParameterRemovalDialogText }}
      </asc-dialog>
      <asc-dialog
        :show-dialog="showCancelDialog"
        :text="getCancelDialogTitle"
        :on-primary="handleExitAndSave"
        :on-secondary="handleExitWithoutSaving"
        :on-close="handleCloseCancelDialog"
        secondary-button-text="Exit Without Saving"
        primary-button-text="Save and Exit"
      >
        {{ getCancelDialogText }}
      </asc-dialog>
      <asc-dialog
        :show-dialog="showVersionChangeConfirmationDialog"
        :text="getVersionChangeConfirmationDialogTitle"
        :on-primary="handleVersionChangeConfirmation"
        :on-secondary="handleVersionChangeCancelation"
        secondary-button-text="Cancel"
        primary-button-text="Confirm"
        :on-close="onVersionChangeCloseDialog"
      >
        {{ getVersionChangeConfirmationDialogText }}
      </asc-dialog>
      <asc-confirmation
        v-if="showDuplicateConfirmationToast"
        :definition="duplicateConfirmationToastDefinition"
        :on-close="handleCloseDuplicateConfirmationToast"
      ></asc-confirmation>
      <asc-confirmation
        v-if="showLogicValidatedToast"
        :definition="logicValidatedToastDefinition"
        :on-close="handleCloseLogicValidatedToast"
      ></asc-confirmation>
      <asc-confirmation
        v-if="dataBricksTriggerResponse.displaySuccessToastMessage"
        :definition="performanceAnalysisValidatedToastDefinition"
        :on-close="handleClosePerformanceAnalysisValidatedToast"
        :on-toast-action="handleSeeEstimateToast"
      ></asc-confirmation>
      <asc-see-estimate-dialog
        :show-dialog="showSeeEstimateDialog"
        :plotly-data="plotlyData"
        :airline="airline"
        :platform="platform"
        :part-numbers="getPartNumberNames"
        :airline-icao-code="getAirlineIcaoCode"
        :on-close-estimate-dialog="handleSeeEstimateClose"
        :alert-data="customAlert"
        :is-single-airline-user="isSingleAirlineUser"
      ></asc-see-estimate-dialog>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscCustomAlertsTitleWrapper from '../../../organisms/AscCustomAlertsTitleWrapper.vue'
import AscCustomAlertsNotificationsWrapper from '../../../organisms/AscCustomAlertsNotificationsWrapper.vue'
import AscCustomAlertsHeaderWrapper from '../../../organisms/AscCustomAlertsHeaderWrapper.vue'
import AscCustomAlertsAddParameterDialog from '../../../molecules/AscCustomAlertsAddParameterDialog.vue'
import AscCustomAlertsAlertTemplate from '../../../templates/AscCustomAlertsAlertTemplate.vue'
import AscConfirmation from '../../../molecules/AscConfirmation.vue'
import AscDialog from '../../../atoms/AscDialog.vue'
import AscPageHeader from '../../../atoms/AscPageHeader.vue'
import AscSurfaceSupportText from '../../../atoms/AscSurfaceSupportText.vue'
import AscSticky from '../../../atoms/AscSticky.vue'
import AscCustomAlertMixin from '../../../mixins/AscCustomAlertMixin.vue'
import AscSeeEstimateDialog from '../../../molecules/AscSeeEstimateDialog.vue'

import AppFeatureFlags from '@/utilities/appFeatureFlags'

import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

import {
  getAdvCustomExpOptions,
  getAllowedAdvCustomExpInputs,
} from '@/utilities/customAlerts'

import {
  CUSTOM_ALERT_PARAMETER_SNAPSHOT_COLUMN_DEFS,
  CUSTOM_ALERT_PARAMETER_FULLFLIGHT_COLUMN_DEFS,
  CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
  CUSTOM_ALERT_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS,
  ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID,
} from '@/utilities/appConsts'

import {
  FULL_FLIGHT_TIER_2,
  COLLINS_PHM_TIER_3,
  COLLINS_PHM_TIER_4,
} from '@/utilities/appConsts'

import {
  USER_CONSTS as UC,
  CUSTOM_ALERT_CONSTS as CAC,
  FLIGHT_PHASE_CONSTS as FP,
  DPLF_CONSTS as DC,
  GLOBAL_FILTER_CONSTS as GF,
  ACMF_REPORT_LIST_CONSTS as ARLC,
  CUSTOM_ALERTS_DERIVED_PARAMETERS_CONSTS as CA_DPC,
  LOOKUP_CONSTS as LC,
  AIRLINE_MANAGEMENT_CONSTS as AOC,
  PLOTLY_CONSTS as PLYC,
} from '@/stores/consts'

export default {
  name: 'AscCustomAlertsAlertContainer',

  components: {
    AscPageLoadingIndicator,
    AscCustomAlertsAlertTemplate,
    AscCustomAlertsAddParameterDialog,
    AscDialog,
    AscConfirmation,
    AscPageHeader,
    AscCustomAlertsNotificationsWrapper,
    AscCustomAlertsHeaderWrapper,
    AscCustomAlertsTitleWrapper,
    AscSurfaceSupportText,
    AscSticky,
    AscSeeEstimateDialog,
  },

  mixins: [AscCustomAlertMixin],
  props: {
    alertType: {
      type: String,
      default: '',
    },
    buildData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      enableValidateBtn: false,
      isSticky: false,
      isDirty: false,
      isCancelHeader: false,
      togglingActive: false,
      togglingActiveValue: null,
      isAlertLoading: false,
      saveDisabled: true,
      activateEnabled: false,
      isParameterListLoading: true,
      isHistogramDataLoading: true,
      showParameterDialog: false,
      showParameterRemovalConfirmationDialog: false,
      showDuplicateConfirmationToast: false,
      selectedParameterId: null,
      selectedAirline: null,
      selectedAirlineName: null,
      selectedParameterName: null,
      selectedSimplePlatformId: null,
      selectedParameterUnit: '',
      showConfiguration: false,
      showAddParameter: true,
      logicExpression: '',
      alertTypeID: 0,
      alertId: this.alertId,
      airline: this.airline,
      airlineId: this.airlineId,
      platform: this.platform,
      platformId: this.platformId,
      reportType: this.reportType,
      reportNumberId: this.reportNumberId,
      customAlertTypeId: this.customAlertTypeId,
      saveLoading: false,
      hasSaved: false,
      showCancelDialog: false,
      logicStringUpdated: false,
      ataChaptersUpdated: false,
      analyticTitleUpdated: false,
      configurationsUpdated: false,
      recommendedActionUpdated: false,
      CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
      CUSTOM_ALERT_SNAPSHOT_DATA_ID,
      ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
      duplicateConfirmationToastDefinition: [
        {
          mode: 'toast',
          type: 'warning',
          text: 'Analytic Duplicated',
          position: 'bottom',
          dismissible: true,
          autoClose: true,
          hasToastAction: false,
          icon: 'mdi-check',
          duration: 6000,
        },
      ],
      airlineTiers: [
        {
          agreementTypeId: COLLINS_PHM_TIER_4, //This is for work item 20082; currently we only want to display Collins PHM Agreement airlines
        },
        {
          agreementTypeId: COLLINS_PHM_TIER_3,
        },
        {
          agreementTypeId: FULL_FLIGHT_TIER_2,
        },
      ],
      validateLoading: false,
      showLogicValidatedToast: false,
      showLogicValidationErrorMessage: false,
      logicValidatedToastDefinition: [
        {
          mode: 'toast',
          type: 'success',
          text: 'Logic validated.',
          icongreen: true,
          dismissible: true,
          hasToastAction: false,
          autoClose: true,
          duration: 6000,
        },
      ],
      performanceAnalysisValidatedToastDefinition: [
        {
          mode: 'toast',
          type: 'success',
          text: 'A performance estimate is ready to view.',
          position: 'bottom',
          toastActionLabel: 'SEE ESTIMATE',
          toastActionLabelColor: '$accent-300',
          icongreen: true,
          dismissible: false,
          hasToastAction: true,
          autoClose: true,
          duration: 6000,
          icon: 'mdi-check',
        },
      ],
      derivedParametersList: [],
      hasDerivedParameter: false,
      showVersionChangeConfirmationDialog: false,
      isTailAlertActive: null,
      isTailNotificationActive: null,
      isAtaChapterAlertActive: null,
      isAtaChapterNotificationActive: null,
      isReportPersistenceAlertActive: null,
      isReportPersistenceNotificationActive: null,
      isDaysPersistenceAlertActive: null,
      isDaysPersistenceNotificationActive: null,
      isFlightsPersistenceAlertActive: null,
      isFlightsPersistenceNotificationActive: null,
      isRecommendedActionAlertActive: null,
      isRecommendedActionNotificationActive: null,
      isThresholdAlertActive: null,
      isThresholdNotificationActive: null,
      isFlightPhaseAlertActive: null,
      isFlightPhaseNotificationActive: null,
      customAlertErrorMessage: null,
      timeoutId: null,
      isCancelClicked: false,
      plotlyData: null,
      showSeeEstimateDialog: false,
      tooltipMsg:
        'Preformance analysis \nis running . Cancel the \nanalysis inorder \nto edit the \nanalytic configuration',
      dataBricksTriggerResponse: {
        isSuccess: false,
        isError: false,
        displaySuccessToastMessage: false,
        displayErrorNotificationMessage: false,
      },
      isDataBricksRunning: false,
    }
  },

  computed: {
    ...mapGetters(UC.NAMESPACE, [
      'isAirlineUser',
      'isAcmfUser',
      'mappedUserAirlines',
      'mappedUserAirlinesWithMasterModels',
    ]),
    ...mapGetters(ARLC.NAMESPACE, [
      'mappedAcmfReportTypesAll',
      'mappedAcmfAirlinesWithMasterModels',
    ]),
    ...mapGetters(LC.NAMESPACE, [
      'mappedLuAtaChapters',
      'mappedLuTailsAll',
      'mappedAirlineMasterModelAgreement',
    ]),
    ...mapState(CAC.NAMESPACE, [
      'parameterList',
      'parameterTailList',
      'customAlert',
      'customAlerts',
      'customAlertTypes',
      'logicBuilderGuide',
      'customAlertFunctionList',
      'partNumbers',
      'dataBricksResponse',
    ]),
    ...mapState(DC.NAMESPACE, ['messageCodes']),
    ...mapState(FP.NAMESPACE, ['flightPhases']),
    ...mapState(GF.NAMESPACE, ['globalFilter']),
    ...mapState(AOC.NAMESPACE, ['airlinesByTier']),
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(PLYC.NAMESPACE, ['plotlyTokens']),
    ...mapState(UC.NAMESPACE, ['profile']),

    isLookBackValid() {
      return this.customAlert?.isLookbackValid
    },
    getRunLimit() {
      return this.airlinesByTier.length > 0 && this.airlineId
        ? this.airlinesByTier.find(x => x.airlineId == this.airlineId).runLimit
        : 0
    },
    enableRunPerformanceEstimate() {
      if (
        this.customAlert?.partNumbers?.length > 0 &&
        this.customAlert?.tails?.length > 0 &&
        this.customAlert?.persistenceFrom <= this.customAlert?.persistenceTo &&
        this.customAlert?.isLookbackValid
      ) {
        if (
          (!this.isDataBricksRunning && !this.enableValidButton) ||
          this.getPerformanceAnalysisName === CAC.SEE_PERFORMANCE_ESTIMATE
        ) {
          return true
        }
        return false
      }

      return false
    },

    getPerformanceAnalysisName() {
      if (this.dataBricksTriggerResponse.isSuccess && this.saveDisabled) {
        return CAC.SEE_PERFORMANCE_ESTIMATE
      }
      return CAC.RUN_PERFORMANCE_ESTIMATE
    },

    getParameterRemovalDialogTitle() {
      return 'Remove Parameter Confirmation'
    },

    getParameterRemovalDialogText() {
      return `You are about to remove this parameter from your analytic. This will reset any customizations you've made.`
    },
    getDataBricksRunId() {
      return this.customAlert?.runId
    },
    getIsActive() {
      return this.alertType.includes('advanced')
        ? this.customAlert.isEnabled && this.logicStringValid
        : this.customAlert.isEnabled
    },

    getCancelDialogTitle() {
      return `Save Changes?`
    },

    getSurfaceSupportText() {
      return this.alertType.includes('advanced')
        ? this.alertType.includes('dplf')
          ? 'Name your custom analytic, set configurations, and begin writing your analytic logic.'
          : 'Create custom analytic logic, add configurations and recommended actions.'
        : 'Name your custom analytic and click "add parameter" to begin.'
    },

    getWarningSupportText() {
      return this.alertType.includes('advanced') && this.alertId == null
        ? 'DO NOT RELOAD OR REFRESH THIS PAGE! A page reload without a save will negate the changes and might result in an error.'
        : ''
    },

    getCancelDialogText() {
      return `This will return you to the custom analytics page. Would you like to save your changes?`
    },

    getVersionChangeConfirmationDialogTitle() {
      return 'CLOSE OPEN MAINTENANCE?'
    },
    getVersionChangeConfirmationDialogText() {
      return 'By updating this analytic, any open maintenance recommendations for the current version will be closed.  New analytics will use the new version.'
    },

    isConfirmationRequired() {
      return (
        this.newVersionFieldsChanged &&
        this.alertType !== 'advanced-dplf' &&
        this.alertId &&
        this.getIsActive
      )
    },

    getUserAirlines() {
      let userAirlines = this.isAcmfUser
        ? this.mappedAcmfAirlinesWithMasterModels
        : this.mappedUserAirlinesWithMasterModels
      return userAirlines
    },

    getAllParameterList() {
      let parameters = []

      // Check if derived parameters exists then only add groupnames to diffrentiate
      if (this.derivedParametersList.length) {
        this.parameterList.map(item => {
          parameters.push({ ...item, ...{ groupName: 'System Parameters' } })
        })

        parameters = [...parameters, ...this.derivedParametersList]
      } else {
        // If no derived params then just append existing params
        parameters = this.parameterList
      }

      return parameters
    },

    mappedFlightPhases() {
      return this.flightPhases
        .filter(flightPhaseObj => {
          return (
            flightPhaseObj.masterModelId ===
            (this.platformId
              ? this.platformId
              : this.selectedSimplePlatformId
              ? this.selectedSimplePlatformId
              : this.parameterTailList.length > 0
              ? this.parameterTailList[0].masterModelId
              : null)
          )
        })
        .map(flightPhaseObj => {
          return {
            text: flightPhaseObj.longName,
            value: flightPhaseObj.dataMapping,
          }
        })
    },

    newVersionFieldsChanged() {
      //logic string, name, ata chapters,
      //configurations section dropdowns, or recommended action changed
      return (
        this.logicStringUpdated ||
        this.analyticTitleUpdated ||
        this.ataChaptersUpdated ||
        this.configurationsUpdated ||
        this.recommendedActionUpdated
      )
    },

    getFullFlightActiveCount() {
      const fullFlightActiveAlerts = this.customAlerts.filter(alertObj => {
        return (
          alertObj.isEnabled &&
          (alertObj.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID ||
            alertObj.customAlertTypeId ===
              ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID ||
            alertObj.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID)
        )
      })
      return fullFlightActiveAlerts.length
    },

    getFilteredParameterColumnDefs() {
      let columnDefs
      if (
        this.customAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
      ) {
        columnDefs = CUSTOM_ALERT_PARAMETER_FULLFLIGHT_COLUMN_DEFS
      } else {
        columnDefs = CUSTOM_ALERT_PARAMETER_SNAPSHOT_COLUMN_DEFS
      }
      if (this.getUserAirlines.length === 1) {
        // if the user is mapped to only 1 airline, then do not show the airline column in add parameter dialog
        columnDefs = columnDefs.filter(columnDefObj => {
          return columnDefObj.field !== 'airline'
        })
      }
      return columnDefs
    },

    getActivateEnabled() {
      return this.activateEnabled
    },
    parentElement() {
      return this.$parent.$el || window
    },

    reportTypesData() {
      return this.mappedAcmfReportTypesAll.map(item => {
        return {
          ...item,
          text: item.text,
          value: item.id,
        }
      })
    },

    logicStringValid: {
      get() {
        if (this.customAlert?.validLogic != null) {
          return this.customAlert?.validLogic
        } else {
          return false
        }
      },
    },

    logicStringValidationErrorText() {
      return 'Logic string not validated: ' + this.customAlertErrorMessage
    },

    isAdvancedFullFlight() {
      return this.alertType === 'advanced-fullflight'
    },

    isAdvancedAcmf() {
      return this.alertType === 'advanced-acmf'
    },

    isAdvancedDplf() {
      return this.alertType === 'advanced-dplf'
    },

    getAllowedCharacterExpInputs() {
      return getAllowedAdvCustomExpInputs()
    },

    getExpressionOptions() {
      return getAdvCustomExpOptions(
        this.isAdvancedFullFlight || this.isAdvancedDplf,
      )
    },

    getAirlinePlatformTierType() {
      var currentAirlineDetails = this.mappedAirlineMasterModelAgreement.filter(
        airline =>
          airline.airlineId === this.airlineId &&
          airline.text === this.platform,
      )
      return currentAirlineDetails[0]?.agreementTypeId
    },
    isDataBricksLoading() {
      if (
        this.dataBricksResponse &&
        this.dataBricksResponse.state &&
        this.dataBricksResponse?.state?.result_state === null
      ) {
        return true
      } else return false
    },

    getAirlineIcaoCode() {
      return this.mappedUserAirlines.filter(
        x => x.airlineId === this.airlineId,
      )[0]?.icaoCode
    },

    getPartNumberNames() {
      const filtered = this.partNumbers.filter(
        partNumber =>
          this.customAlert?.partNumbers?.indexOf(partNumber.value) > -1,
      )

      return filtered.map(partNumber => partNumber.text).join(', ')
    },

    isSingleAirlineUser() {
      return this.mappedUserAirlines.length === 1
    },
    displayRunPerformanceSection() {
      // Allowing to display Run performance button for aal, ana, jal,kal, sva, tgw, fhy & sia
      // with platform id as A320 & 787
      if (
        (this.airlineId === 1 && this.platform === '787') ||
        (this.airlineId === 2 && this.platform === '787') ||
        (this.airlineId === 115 && this.platform === '787') ||
        (this.airlineId === 175 &&
          (this.platform === '787' || this.platform === 'A320')) ||
        (this.airlineId === 176 && this.platform === '787') ||
        (this.airlineId === 181 && this.platform === '787') ||
        (this.airlineId === 615 && this.platform === 'A320')
      ) {
        return true
      } else {
        return false
      }
    },
    getIsReadOnly() {
      return (
        this.customAlert.isShared &&
        this.customAlert.userId != undefined &&
        this.customAlert.userId !== this.profile.userId
      )
    },
  },

  watch: {
    '$route.params.alertId': function (id) {
      this.alertId = id
    },
  },

  async created() {
    // if alert is an advanced alert, populate tail list
    this.isAlertLoading = true
    if (this.buildData) {
      this.airline = this.buildData.airline
      this.platform = this.buildData.platform
      this.platformId = this.buildData.platformId
      this.reportType = this.buildData.reportType
      this.airlineId = this.buildData.airlineId
      this.reportNumberId = this.buildData.reportNumberId
      this.customAlertTypeId = this.buildData.customAlertTypeId
    }

    if (this.alertType.includes('advanced')) {
      const alertTypeSelection = this.alertType.split('-')[1]?.toUpperCase()
      this.getCorrespondingLogicBuilderGuide(alertTypeSelection)
      await this.getAtaChapterList()
    }
    // Follow the comments sequence for understanding
    // 1. Moved all the preload fields of different alert types to a different method and refactored

    // if the alert is brand new...store a new alert in the store

    if (!this.$route.params.alertId) {
      //4 . Included here for the Usage of 3rd comment changes & make sure only to let advanced alerts
      if (this.alertType.includes('advanced')) {
        await this.loadAdvancedAlertTypeBasedFields() // 2. Included & called here to avoid reduduncy with the conditions
        this.setDefaultTailList()
      }
      this.showDuplicateConfirmationToast = false
      this[CAC.UPDATE_CUSTOM_ALERT]({
        name:
          this.alertType === 'fullflight'
            ? 'Full Flight Data Analytic'
            : this.isAdvancedAcmf
            ? 'Advanced Logic ACMF Data Analytic'
            : this.isAdvancedFullFlight
            ? 'Advanced Logic Full Flight Data Analytic'
            : this.isAdvancedDplf
            ? 'Advanced Logic Fault Code Data Analytic'
            : 'ACMF Data Analytic',
        customAlertTypeId:
          this.alertType === 'fullflight'
            ? CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
            : this.alertType === 'acmf'
            ? CUSTOM_ALERT_SNAPSHOT_DATA_ID
            : this.customAlertTypeId,
        id: null,
        persistenceFrom: 1,
        persistenceTo: 1,
        aggregateDays: null,
        aggregateReports: null,
        configurationType: 'persistence',
        airlineId: this.alertType.includes('advanced') ? this.airlineId : null,
        platformId: this.alertType.includes('advanced')
          ? this.platformId
          : null,
        acmfReportNumberId: this.isAdvancedAcmf ? this.reportNumberId : null,
        severityLevel: this.alertType.includes('advanced')
          ? 'highWarning'
          : null,
        isShared: false,
      })
      // 3. Moved it up to use its condition for other
      this.isAlertLoading = false
    } else {
      // if the alert isn't brand new, query to get the alert and update the stores
      this.alertId = this.$route.params.alertId
      this.isAlertLoading = true
      this.hasSaved = true

      if (this.$route.params.isADuplicate) {
        this.showDuplicateConfirmationToast = true
      }

      if (!this.customAlertTypes.length) {
        await this[CAC.GET_CUSTOM_ALERT_TYPES]()
      }
      await this[CAC.GET_CUSTOM_ALERT](this.alertId)
      this.saveDisabled = true

      if (
        ADVANCED_CUSTOM_ALERTS.find(
          item => item.id === this.customAlert.customAlertTypeId,
        )
      ) {
        await Promise.all([
          this[ARLC.GET_ACMF_REPORT_TYPES](),
          this[ARLC.GET_ACMF_AIRLINES](),
          this[ARLC.GET_ACMF_MASTER_MODELS](),
          this[CAC.GET_PART_NUMBERS]({
            platformId: this.customAlert.platformId,
            airlineId: this.customAlert.airlineId,
          }),
          this[CAC.GET_CUSTOM_ALERT_PERFORMANCE](),
        ])
        this.checkJobState()
        const airlineAssigned = this.mappedUserAirlinesWithMasterModels.find(
          item => item.airlineId === this.customAlert.airlineId,
        )
          ? this.mappedUserAirlinesWithMasterModels.find(
              item => item.airlineId === this.customAlert.airlineId,
            )
          : this.mappedAcmfAirlinesWithMasterModels.find(
              item => item.airlineId === this.customAlert.airlineId,
            )

        const reportAssigned = this.mappedAcmfReportTypesAll.find(
          item => item.id === this.customAlert.acmfReportNumberId,
        )
        this.airlineId = airlineAssigned ? airlineAssigned.airlineId : 0
        this.platformId = this.customAlert.platformId
        this.alertType = this.$route.params.alertType
        this.customAlertTypeId = this.customAlert.customAlertTypeId

        const reportNumber = reportAssigned
          ? reportAssigned.text.split(' - ')[0].trim()
          : ''
        const tailsByPlatformAndAirline =
          this.customAlert.customAlertTypeId !=
          ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID
            ? this.getTailsByPlatformAndAirline()
            : null
        await this.getTailListForAdvancedAlert(
          reportNumber,
          tailsByPlatformAndAirline,
        )
        const alertTypeSelection = this.alertType.split('-')[1]?.toUpperCase()
        this.getCorrespondingLogicBuilderGuide(alertTypeSelection)

        const parameterListData = {
          reportType: this.customAlert.acmfReportNumberId,
          airlineId: this.customAlert.airlineId,
        }

        const platformData = airlineAssigned?.items.find(
          x => x.masterModelId === this.customAlert.platformId,
        )

        this.airline = airlineAssigned ? airlineAssigned.text : ''
        this.platform = platformData ? platformData.text : ''
        this.reportType = reportAssigned ? reportAssigned.text : ''
        this.logicExpression = this.customAlert.expression
        this.isAdvancedAcmf
          ? this.getSnapshotParameterListForModal(parameterListData)
          : this.isAdvancedFullFlight
          ? (this.getFullFlightParameterListForModal(
              this.airlineId,
              this.platformId,
            ),
            this.getDerivedParametersList(this.airlineId, this.platformId))
          : this.getAllMessageCodes()

        // Refactoring to be done around these changes
        if (this.isAdvancedFullFlight || this.isAdvancedDplf)
          await this.getFlightPhaseList()

        this.activateEnabled = this.calculateActivateEnabledAdvanced({
          ...this.customAlert,
          alertType: this.alertType,
        })

        this.isAlertLoading = false
        this.showAddParameter = true
        this.showConfiguration = false
      } else {
        if (this.customAlert.parameterId != null) {
          await this.getTailListForParameter()
          if (
            this.customAlert.customAlertTypeId ===
            CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
          ) {
            await this.getFlightPhaseList()
            // for new alerts, flight phase gets set to all
            if (!this.alertId) {
              const flightPhases = this.flightPhases.map(flightPhaseObj => {
                return flightPhaseObj.value
              })
              this[CAC.UPDATE_CUSTOM_ALERT]({ flightPhase: flightPhases })
            }
          }
          this.selectedParameterName = this.customAlert.parameterName
          const airlineName = this.mappedUserAirlines.filter(airlineObj => {
            return airlineObj.airlineId === this.customAlert.airlineId
          })
          this.selectedAirlineName =
            airlineName.length > 0 ? airlineName[0].airlineName : ''
          this.isAlertLoading = false
          this.showConfiguration = true
          this.showAddParameter = false
          this.isHistogramDataLoading = true
          this.activateEnabled = this.calculateActivateEnabled({
            ...this.customAlert,
            alertType: this.alertType,
          })
          await this.loadHistogramData()
          this.isHistogramDataLoading = false
        } else {
          this.isAlertLoading = false
          this.showAddParameter = true
          this.showConfiguration = false
        }
      }
    }

    if (this.alertType.includes('advanced')) {
      await this[CAC.GET_CUSTOM_ALERT_FUNCTIONS](
        this.isAdvancedFullFlight
          ? ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID
          : this.isAdvancedDplf
          ? ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID
          : ADVANCED_CUSTOM_ALERTS_SNAPSHOT_DATA_ID,
      )
    }
  },

  beforeDestroy() {
    this[CAC.RESET_CURRENT_CUSTOM_ALERT]()
    this[DC.RESET_CURRENT_DPLF_VALUES]()
    this[CAC.UPDATE_DATABRICKS_RESPONSE](null)
    window.removeEventListener('scroll', this.handlePageScroll, true)
    window.removeEventListener('resize', this.handlePageResize)
    if (this.timeoutId !== null) clearTimeout(this.timeoutId)
  },

  mounted() {
    window.addEventListener('scroll', this.handlePageScroll, true)
    window.addEventListener('resize', this.handlePageResize)
  },

  methods: {
    ...mapMutations(CAC.NAMESPACE, [CAC.UPDATE_DATABRICKS_RESPONSE]),
    ...mapActions(CAC.NAMESPACE, [
      CAC.GET_PARAMETER_LIST,
      CAC.SAVE_CUSTOM_ALERT,
      CAC.GET_FULLFLIGHT_PARAMETER_LIST,
      CAC.GET_SNAPSHOT_PARAMETER_LIST,
      CAC.UPDATE_CUSTOM_ALERT,
      CAC.GET_PARAMETER_TAIL_LIST,
      CAC.GET_CUSTOM_ALERT,
      CAC.GET_CUSTOM_ALERT_TYPES,
      CAC.GET_HISTOGRAM_DATA,
      CAC.UPDATE_PARAMETER_LIST,
      CAC.DUPLICATE_CURRENT_ALERT,
      CAC.RESET_CURRENT_CUSTOM_ALERT,
      CAC.GET_ADVANCED_ALERT_TAIL_LIST,
      CAC.GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE,
      CAC.UPDATE_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE,
      CAC.GET_LOGIC_VALIDATION,
      CAC.GET_CUSTOM_ALERT_FUNCTIONS,
      CAC.GET_PART_NUMBERS,
      CAC.GET_CUSTOM_ALERT_PERFORMANCE,
      CAC.TRIGGER_DATABRICKS,
      CAC.GET_LOOKBACK_STATE_RUNID,
      CAC.CANCEL_LOOKBACK,
      CAC.GET_LOOKBACK_RUNCOUNT,
    ]),
    ...mapActions(FP.NAMESPACE, [FP.GET_FLIGHT_PHASES]),

    ...mapActions(DC.NAMESPACE, [
      DC.GET_MESSAGE_CODES,
      DC.RESET_CURRENT_DPLF_VALUES,
    ]),

    ...mapActions(CA_DPC.NAMESPACE, [
      CA_DPC.GET_DERIVED_PARAMETERS_BY_AIRLINE_ID,
    ]),

    ...mapActions(AOC.NAMESPACE, [AOC.FIND_AIRLINES]),

    ...mapActions(ARLC.NAMESPACE, [
      ARLC.GET_ACMF_REPORT_TYPES,
      ARLC.GET_ACMF_AIRLINES,
      ARLC.GET_ACMF_MASTER_MODELS,
    ]),

    ...mapActions(LC.NAMESPACE, [LC.GET_ATA_CHAPTERS]),
    handleLaunchAddParameterDialog() {
      this.showParameterDialog = true
      this.isParameterListLoading = true
      if (this.alertType === 'acmf') {
        this.loadAcmfReportTypes()
      } else {
        this.getFullFlightParameterListForModal()
      }
    },

    async loadAcmfReportTypes() {
      await this[ARLC.GET_ACMF_REPORT_TYPES]()
      await this[ARLC.GET_ACMF_AIRLINES]()
      await this[ARLC.GET_ACMF_MASTER_MODELS]()
      this.isParameterListLoading = false
    },

    async getSnapshotParameterListForModal(data) {
      this.isParameterListLoading = true
      await this[CAC.GET_SNAPSHOT_PARAMETER_LIST](data)
      this.isParameterListLoading = false
    },

    async getFullFlightParameterListForModal(
      selectedAirline,
      selectedPlatform,
    ) {
      await this[AOC.FIND_AIRLINES](this.airlineTiers)
      const alertTypeAirlines =
        this.alertType === 'fullflight'
          ? this.airlinesByTier
          : this.mappedUserAirlines
      const mappedUserAirlines = selectedAirline
        ? [{ airlineId: selectedAirline }]
        : alertTypeAirlines
      await this[CAC.GET_FULLFLIGHT_PARAMETER_LIST]({
        airlineIds: mappedUserAirlines,
        platformId: selectedPlatform ? selectedPlatform : null,
      })
      this.isParameterListLoading = false
    },

    async getDerivedParametersList(airlineId, masterModelId) {
      // DerivedParameters
      if (airlineId && AppFeatureFlags.getDerivedParameters()) {
        // Get all user defined derived parameters for advanced custom alerts
        // by selected airlineId
        const derivedParametersList = await this[
          CA_DPC.GET_DERIVED_PARAMETERS_BY_AIRLINE_ID
        ]({ airlineId: airlineId, masterModelId: masterModelId })

        if (derivedParametersList && derivedParametersList.length) {
          this.derivedParametersList = derivedParametersList.map(item => {
            return {
              ...item,
              ...{
                rawName: `DP_${item.name.replace(/\s+/g, '_').toUpperCase()}`,
                groupName: 'Custom Parameters',
              },
            }
          })

          // Update expression with derived paramters id once API is completed
          // If not the derived paramters wont be updated with :id and the alerts wont trigger
          if (this.customAlert.expression) {
            const expressionObj = {
              expression: this.getUpdatedExpIfDerivedParams(
                this.customAlert.expression,
              ),
            }
            if (this.customAlert.expression !== expressionObj.expression) {
              this[CAC.UPDATE_CUSTOM_ALERT](expressionObj)
            }
          }
        }
      }
    },

    async getTailListForParameter() {
      this.isParameterListLoading = true
      await this[CAC.GET_PARAMETER_TAIL_LIST]({
        parameterId: this.customAlert.parameterId,
        airlineId: this.customAlert.airlineId,
        alertType: this.alertType,
        reportNumberId: this.customAlert.acmfReportNumberId
          ? this.customAlert.acmfReportNumberId
          : null,
      })
      this.selectedParameterUnit = this.customAlert.parameterUnitName
      this.isParameterListLoading = false
    },

    async getTailListForAdvancedAlert(
      reportNumber = null,
      tailsByPlatformAndAirline = null,
    ) {
      await this[CAC.GET_ADVANCED_ALERT_TAIL_LIST]({
        airlineId: this.airlineId,
        alertType: this.alertType,
        reportNumber: reportNumber,
        platformId: this.platformId,
        tailsByPlatformAndAirline: tailsByPlatformAndAirline,
      })
    },

    async getAtaChapterList() {
      this.isParameterListLoading = true
      await this[LC.GET_ATA_CHAPTERS]()
      this.isParameterListLoading = false
    },
    async getFlightPhaseList() {
      this.isParameterListLoading = true
      await this[FP.GET_FLIGHT_PHASES]()
      this.isParameterListLoading = false
    },

    async getAllMessageCodes() {
      this.isParameterListLoading = true
      await this[DC.GET_MESSAGE_CODES]({
        masterModelIds: [this.platformId],
      })
      this.isParameterListLoading = false
    },

    async loadHistogramData() {
      this.isAlertLoading = true
      this.isHistogramDataLoading = true
      let flightPhases = []
      if (
        this.customAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
      ) {
        flightPhases =
          this.customAlert.flightPhase.length === this.flightPhases.length
            ? []
            : this.customAlert.flightPhase
      }
      await this[CAC.GET_HISTOGRAM_DATA]({
        parameterId: this.customAlert.parameterId,
        airlineId: this.customAlert.airlineId,
        alertType: this.alertType,
        reportId:
          this.customAlert.customAlertTypeId === CUSTOM_ALERT_SNAPSHOT_DATA_ID
            ? this.customAlert.acmfReportNumberId
            : null,
        maxFlights:
          this.customAlert.customAlertTypeId ===
          CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
            ? 10
            : 100,
        flightPhase: flightPhases,
      })
      this.isAlertLoading = false
      this.isHistogramDataLoading = false
    },

    handleSave() {
      this.evaluateAllAlerts()
      if (this.areAnyAlertsActive()) {
        this.setNotificationStatuses()
      }
      this.isCancelHeader = false
      this.togglingActive = false
      if (this.isConfirmationRequired) {
        this.showVersionChangeConfirmationDialog = true
      } else {
        this.handleSaveAlert()
      }
    },
    evaluateAllAlerts() {
      this.evaluteTailsAlert(this.customAlert.tails)
      if (
        !(
          this.customAlert.customAlertTypeId === CAC.ACMF_ADVANCED_ID &&
          (this.customAlert.configurationType === CAC.PERSISTENCE_DAYS_TYPE ||
            this.customAlert.configurationType === CAC.PERSISTENCE_REPORTS_TYPE)
        )
      ) {
        this.evaluateFlightsPersistenceAlert()
      }
      if (
        this.customAlert.customAlertTypeId === CAC.ACMF_ADVANCED_ID ||
        this.customAlert.customAlertTypeId === CAC.CPL_ADVANCED_ID
      ) {
        this.evaluateAtaChapterAlert(this.customAlert.ataChapters)
        this.evaluateRecActionAlert(this.customAlert.recAction)
      }

      if (
        this.customAlert.customAlertTypeId === CAC.ACMF_SIMPLE_ID ||
        this.customAlert.customAlertTypeId === CAC.CPL_SIMPLE_ID
      ) {
        this.evaluateThresholdAlert()
      }

      if (this.customAlert.customAlertTypeId === CAC.CPL_SIMPLE_ID) {
        this.evaluateFlightPhaseAlert(this.customAlert.flightPhase)
      }

      if (this.customAlert.customAlertTypeId === CAC.ACMF_ADVANCED_ID) {
        if (this.customAlert.configurationType === CAC.PERSISTENCE_DAYS_TYPE) {
          this.evaluateDaysPersistenceAlert(this.customAlert.aggregateDays)
        }
        if (
          this.customAlert.configurationType === CAC.PERSISTENCE_REPORTS_TYPE
        ) {
          this.evaluateReportPersistenceAlert(this.customAlert.aggregateReports)
        }
      }
    },
    areAnyAlertsActive() {
      return (
        this.isTailAlertActive ||
        this.isAtaChapterAlertActive ||
        this.isFlightPhaseAlertActive ||
        this.isThresholdAlertActive ||
        this.isReportPersistenceAlertActive ||
        this.isDaysPersistenceAlertActive ||
        this.isFlightsPersistenceAlertActive ||
        this.isRecommendedActionAlertActive
      )
    },
    setNotificationStatuses() {
      this.isTailNotificationActive = this.isTailAlertActive
      this.isAtaChapterNotificationActive = this.isAtaChapterAlertActive
      this.isFlightPhaseNotificationActive = this.isFlightPhaseAlertActive
      this.isThresholdNotificationActive = this.isThresholdAlertActive
      this.isReportPersistenceNotificationActive =
        this.isReportPersistenceAlertActive
      this.isDaysPersistenceNotificationActive =
        this.isDaysPersistenceAlertActive
      this.isFlightsPersistenceNotificationActive =
        this.isFlightsPersistenceAlertActive
      this.isRecommendedActionNotificationActive =
        this.isRecommendedActionAlertActive
    },
    async handleSaveAlert(isPerformanceAnalysisClicked = false) {
      this.saveLoading = true
      this.saveDisabled = true
      this.hasSaved = true
      this.isDirty = false
      this.logicStringUpdated = false
      this.configurationsUpdated = false
      this.ataChaptersUpdated = false
      this.analyticTitleUpdated = false
      this.recommendedActionUpdated = false
      this.dataBricksTriggerResponse.isSuccess = false
      if (this.customAlertTypes.length === 0) {
        await this[CAC.GET_CUSTOM_ALERT_TYPES]()
      }

      await this[CAC.SAVE_CUSTOM_ALERT]()
      await this[CAC.GET_CUSTOM_ALERT](this.customAlert.id)
      await this[CAC.GET_CUSTOM_ALERT_PERFORMANCE]()
      if (isPerformanceAnalysisClicked) {
        this.updateDataBrickState()
        await this[CAC.TRIGGER_DATABRICKS]()
      }
      if (!this.alertId) {
        // need to redirect the user to the new alert
        const customAlertData = {
          customAlertTypeId: this.customAlertTypeId,
          airline: this.airline,
          reportType: this.reportType,
          airlineId: this.airlineId,
          platform: this.platform,
          platformId: this.platformId,
          reportNumberId: this.reportNumberId,
        }

        this.$router
          .push({
            name: 'Custom Analytic',
            params: {
              alertType: this.alertType,
              alertId: this.customAlert.id,
              buildData: customAlertData,
            },
          })
          .catch(err => {
            throw new Error(`Problem navigating: ${err}.`)
          })
      }
      this.saveLoading = false
    },

    async handleLogicValidate(value) {
      this.validateLoading = true
      this.showLogicValidationErrorMessage = false
      if (!value || value.length === 0) {
        this.customAlert.errorMessage = 'Logic String cannot be empty'
        this.showErrorMessage()
        return
      }

      value = value.toUpperCase()

      if (
        this.isAdvancedAcmf &&
        (!this.isPersistenceLogicStringWithoutAdvFunction(value) ||
          !this.areParametersValid(value))
      ) {
        this.showErrorMessage()
        return
      }

      if (
        (this.isAdvancedFullFlight || this.isAdvancedDplf) &&
        !this.areFlightPhasesValid(value)
      ) {
        this.showErrorMessage()
        return
      }

      if (this.isAdvancedDplf && !this.areMessageCodesValid(value)) {
        this.customAlertErrorMessage = this.customAlert?.errorMessage
        this.showErrorMessage()
        return
      }

      const savedExpression = this.customAlert.expression
        ? this.customAlert.expression
        : ''

      // Parameters are not available for Dplf
      if (this.isAdvancedDplf) {
        await this.invokeLogicValidation(value)
        this.customAlertErrorMessage = this.customAlert?.errorMessage
      } else {
        const count = this.getNumberOfParameters(savedExpression)

        if (count > CAC.ADVANCED_CUSTOM_ALERT_PARAMETER_LIMIT) {
          this.logicStringValid = false
          this.customAlert.errorMessage = `Your logic exceeds the limit of ${CAC.ADVANCED_CUSTOM_ALERT_PARAMETER_LIMIT} distinct parameters. Please reduce your parameter count and try again.`
        } else {
          // If the expression has derived params then replace params with [params_raw_name:paramsId]
          await this.invokeLogicValidation(
            this.getUpdatedExpIfDerivedParams(value),
          )
        }
      }

      this.validateLoading = false

      if (this.logicStringValid) {
        this.enableValidateBtn = false
        this.showLogicValidationErrorMessage = false
        this.showLogicValidatedToast = true
        this.activateEnabled = this.calculateActivateEnabledAdvanced({
          ...this.customAlert,
          alertType: this.alertType,
        })
        this.handleChangeSaveDisabled(false)
      } else {
        this.showLogicValidatedToast = false
        this.showLogicValidationErrorMessage = true

        if (this.customAlert.isEnabled) {
          this.$emit('handleToggleActivate', false)
        }
      }
    },
    async handleCancelPerformanceAnalysis() {
      if (this.customAlert.runId) {
        this.isDataBricksRunning = false
        this.isCancelClicked = true
        this.updateDataBrickState()
        if (this.timeoutId !== null) clearTimeout(this.timeoutId)
        await this[CAC.CANCEL_LOOKBACK]()
      }
    },
    // eslint-disable-next-line no-unused-vars
    async handlePerformanceAnanlysis(date) {
      if (this.getPerformanceAnalysisName === CAC.RUN_PERFORMANCE_ESTIMATE) {
        this.updateDataBrickState()
        this.isCancelClicked = false
        let isPerformanceAnalysisClicked = true
        let saveDisabled = this.saveDisabled
        if (this.isLookBackValid) {
          this.isDataBricksRunning = true
          if (this.customAlert.customAlertId && saveDisabled) {
            await this[CAC.TRIGGER_DATABRICKS]()
            this.checkJobState()
          } else {
            await this.handleSaveAlert(isPerformanceAnalysisClicked)
            if (!saveDisabled) {
              this.checkJobState()
            }
          }
        }
      }
    },
    handleClosePerformanceAnalysisValidatedToast() {
      this.dataBricksTriggerResponse.displaySuccessToastMessage = false
    },
    handleDatabricksErrorNotificationClose() {
      this.dataBricksTriggerResponse.displayErrorNotificationMessage = false
    },
    async checkJobState() {
      if (!this.isCancelClicked) {
        let runId =
          this.getDataBricksRunId != null ? this.getDataBricksRunId : 0
        if (runId !== 0) {
          this.updateDataBrickState()
          this.isDataBricksRunning = true
          await this[CAC.GET_LOOKBACK_STATE_RUNID](runId)
          if (this.isDataBricksLoading) {
            this.timeoutId = setTimeout(this.checkJobState, 10000)
          } else {
            this.displayDataBricksSuccessOrErrorNotification()
            this.isDataBricksRunning = false
            if (this.timeoutId !== null) clearTimeout(this.timeoutId)
            this.timeoutId = null
          }
        } else {
          this.isDataBricksRunning = false
          this.updateDataBrickState()
        }
      } else {
        this.isDataBricksRunning = false
        this.updateDataBrickState()
        this.timeoutId = null
      }
    },
    displayDataBricksSuccessOrErrorNotification() {
      if (this.dataBricksResponse?.state?.result_state === 'SUCCESS') {
        this.updateDataBrickState(true, false, true, false)
      } else if (
        this.dataBricksResponse?.state?.result_state === null ||
        this.dataBricksResponse?.state?.result_state === 'CANCELED'
      ) {
        this.updateDataBrickState(false, false, false, false)
      } else {
        this.updateDataBrickState(false, true, false, true)
      }
    },
    updateDataBrickState(
      isSuccess = false,
      isError = false,
      displaySuccessToastMessage = false,
      displayErrorNotificationMessage = false,
    ) {
      this.dataBricksTriggerResponse = {
        ...this.dataBricksTriggerResponse,
        isSuccess,
        isError,
        displaySuccessToastMessage,
        displayErrorNotificationMessage,
      }
    },
    getUpdatedExpIfDerivedParams(value) {
      let expressionValue = value
      const derivedParamsRegEx = /\[dp_.*?\]/gi
      const derviedParameters = (value || '').match(derivedParamsRegEx) || []

      if (derviedParameters.length && this.derivedParametersList.length) {
        this.hasDerivedParameter = true
        derviedParameters.forEach(param => {
          const foundDerivedParam = this.derivedParametersList.find(
            dp => dp.rawName === param.replace(/[[\]']+/g, ''),
          )

          if (foundDerivedParam) {
            expressionValue = expressionValue.replace(
              param,
              `[${foundDerivedParam.rawName}:${foundDerivedParam.id}]`,
            )
          }
        })
        return expressionValue
      } else {
        this.hasDerivedParameter = false
        if (derviedParameters.length) {
          this.hasDerivedParameter = true
        }
        return value
      }
    },

    showErrorMessage() {
      this.showLogicValidatedToast = false
      this.showLogicValidationErrorMessage = true
      this.validateLoading = false
    },

    async invokeLogicValidation(logicString) {
      await this[CAC.GET_LOGIC_VALIDATION]({
        logicString: logicString,
        alertTypeId: this.customAlertTypeId,
      })
    },

    areParametersValid(value) {
      const regexForParameters = /(?<=\[)[^\][]*(?=])/g
      const userParameterList = value.match(regexForParameters)

      if (userParameterList) {
        for (const parameterItem of userParameterList) {
          let parameterFound = ''

          if (this.isAdvancedFullFlight) {
            parameterFound = this.parameterList.find(
              item => parameterItem.trim() === item.displayName,
            )
          } else {
            parameterFound = this.parameterList.find(
              item => parameterItem.trim() === item.parameterName,
            )
          }

          if (parameterFound === undefined) {
            this.customAlert.errorMessage =
              'Parameter Not Found: ' + parameterItem
            return false
          }
        }
        return true
      } else {
        this.customAlert.errorMessage = 'Expression requires parameters'
        return false
      }
    },

    areFlightPhasesValid(value) {
      const regexForFlightPhase = /(?<=FLIGHTPHASE\()[^\][()]*(?=\))/g
      const flightPhaseList = value.match(regexForFlightPhase)

      if (flightPhaseList) {
        for (const flightPhaseItem of flightPhaseList) {
          let flightPhaseFound = ''
          flightPhaseFound = this.mappedFlightPhases.find(
            item => flightPhaseItem.trim() == item.value,
          )

          if (flightPhaseFound === undefined) {
            this.customAlert.errorMessage =
              'Flight Phase Not Found: ' + flightPhaseItem
            return false
          }
        }
      }
      return true
    },

    areMessageCodesValid(value) {
      // To Check Message Codes Count exceeds 4
      const messageCodesCount = (value.match(/MESSAGE_CODE/g) || []).length
      if (messageCodesCount > 4) {
        this.customAlert.errorMessage = ' Limit of 4 Message Codes exceeded'
        return false
      }

      // To Check Message Codes are enclosed within an Advanced Function
      const regexForMessageCodeWithFunction =
        /COUNT\s*?\(\s*?\[MESSAGE_CODE.*?\)/g
      const functionEnclosedMessageCodes =
        value.match(regexForMessageCodeWithFunction) || []

      if (messageCodesCount != functionEnclosedMessageCodes.length) {
        this.customAlert.errorMessage =
          'One/more Message Codes are not enclosed by any function'
        return false
      }

      for (const functionBlock of functionEnclosedMessageCodes) {
        const isFlightPhaseIncluded = functionBlock.includes('FLIGHTPHASE')

        const regexForMessageCode = /(?<=\[MESSAGE_CODE\]+\s*?=+\s*?)\d+/g
        const matchedMessageCodes = functionBlock.match(regexForMessageCode)

        if (matchedMessageCodes) {
          for (const messageCodeItem of matchedMessageCodes) {
            // To Check Message Codes are Valid
            const messageCodeValue = Number(messageCodeItem)
            if (!this.messageCodes.includes(messageCodeValue)) {
              this.customAlert.errorMessage =
                'Message Code Not Found: ' + messageCodeItem
              return false
            }
            // To Check Message Code's length exceeds 7 to disallow FlightPhase
            else if (messageCodeItem.length >= 8 && isFlightPhaseIncluded) {
              this.customAlert.errorMessage =
                'Flight phase not allowed with FDE/MMO. Length of Message Code for ' +
                messageCodeItem +
                ' is ' +
                messageCodeItem.length
              return false
            }
          }
        }
      }
      return true
    },

    isPersistenceLogicStringWithoutAdvFunction(value) {
      if (
        this.customAlert.configurationType === 'persistence' &&
        this.isAdvancedAcmf
      ) {
        const advFunctions = this.customAlert.advancedFunction
        for (const advFunction of advFunctions) {
          const regularEx = /([^[\]]+)(?:$|\[)/g
          const persistenceString = value.match(regularEx).toString()

          if (persistenceString.includes(advFunction)) {
            this.customAlert.errorMessage =
              'Advanced Functions are not allowed for Persistence - Flights'
            return false
          }
        }
        return true
      } else return true
    },

    handleTextUpdated(value) {
      const expressionObj = {
        validLogic: false,
        isEnabled: false,
        isLookbackValid: null,
        expression: this.getUpdatedExpIfDerivedParams(value),
      }
      if (this.customAlert.expression !== value) {
        this.enableValidateBtn = true
        this.logicStringUpdated = true
        this.handleChangeSaveDisabled(false)
        this[CAC.UPDATE_CUSTOM_ALERT](expressionObj)
        this.handleChangeActivateEnabled(false)
      }
    },

    getNumberOfParameters(expr) {
      const re = /\[.*?\]/gi
      const count = ((expr || '').match(re) || []).length
      return count
    },

    setDefaultTailList() {
      // for new acmf alerts OR if the alert has been saved but flight phase is null (meaning it was never set), all tails are
      const selectedTails = this.parameterTailList.map(parameterTailListObj => {
        return parameterTailListObj.value
      })
      this[CAC.UPDATE_CUSTOM_ALERT]({ tails: selectedTails })
    },

    getTailsByPlatformAndAirline() {
      return this.mappedLuTailsAll.filter(
        tailObj =>
          tailObj.masterModelId === this.platformId &&
          tailObj.airlineId === this.airlineId,
      )
    },

    async getCorrespondingLogicBuilderGuide(alertTypeSelection) {
      await this[CAC.GET_CUSTOM_ALERT_LOGIC_BUILDER_GUIDE](alertTypeSelection)
    },

    handleUpdateAlertName(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ name: value })
      this.analyticTitleUpdated = true
    },

    handleUpdateAlertDescription(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ analyticDescription: value })
    },

    handleChangeSaveDisabled(value) {
      this.saveDisabled = value
    },

    handleChangeActivateEnabled(value) {
      this.activateEnabled = value
    },

    handleUpdateSnapshotAlertAirline(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ airlineId: value })
    },

    handleUpdateSnapshotAlertReportType(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ acmfReportNumberId: value })
    },

    async handleUpdateFlightPhase(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ flightPhase: value })
      // for full flight alerts, update the histogram when the flight phase changes.
      if (
        this.customAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
      ) {
        this.isHistogramDataLoading = true
        await this.loadHistogramData()
        this.isHistogramDataLoading = false
        this.activateEnabled = this.calculateActivateEnabled({
          ...this.customAlert,
          alertType: this.alertType,
        })
      }
    },
    handleChangePersistenceFrom(value) {
      this.persistenceFrom = value
      this[CAC.UPDATE_CUSTOM_ALERT]({ persistenceFrom: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluateFlightsPersistenceAlert(value)
      this.configurationsUpdated = true
    },
    evaluateFlightsPersistenceAlert() {
      if (this.customAlert.persistenceFrom > this.customAlert.persistenceTo) {
        this.isFlightsPersistenceAlertActive = true
      } else {
        this.isFlightsPersistenceAlertActive = false
        this.isFlightsPersistenceNotificationActive = false
      }
    },
    handleChangeTails(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ tails: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluteTailsAlert(value)
      this.configurationsUpdated = true
    },
    evaluteTailsAlert(value) {
      if (value.length) {
        this.isTailAlertActive = false
        this.isTailNotificationActive = false
      } else {
        this.isTailAlertActive = true
      }
    },
    handleChangePartNumbers(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ partNumbers: value })
      this.activateEnabled = this.getActivateStatus()
      this.configurationsUpdated = true
    },
    handleChangeIsDirty() {
      this.isDirty = true
    },
    handleChangeIsShared(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ isShared: value })
      this.activateEnabled = this.getActivateStatus()
    },
    handleChangeRecAction(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ recAction: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluateRecActionAlert(value)
      this.recommendedActionUpdated = true
    },
    evaluateRecActionAlert(value) {
      if (value?.length !== 7 && value !== null && value !== undefined) {
        this.isRecommendedActionAlertActive = false
        this.isRecommendedActionNotificationActive = false
      } else {
        this.isRecommendedActionAlertActive = true
      }
    },
    handleChangeAtaChapters(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ ataChapters: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluateAtaChapterAlert(value)
      this.ataChaptersUpdated = true
    },
    evaluateAtaChapterAlert(value) {
      if (value?.length !== 0 && (value !== null) & (value !== undefined)) {
        this.isAtaChapterAlertActive = false
        this.isAtaChapterNotificationActive = false
      } else {
        this.isAtaChapterAlertActive = true
      }
    },

    handleClearHistogramData() {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        histogramData: [],
        flightPhase: [],
      })
    },

    handleChangePersistenceTo(value) {
      this.persistenceTo = value
      this[CAC.UPDATE_CUSTOM_ALERT]({ persistenceTo: value })
      this.activateEnabled = this.getActivateStatus()
      if (value < this.persistenceFrom) {
        this.isFlightsPersistenceAlertActive = true
      } else {
        this.isFlightsPersistenceAlertActive = false
        this.isFlightsPersistenceNotificationActive = false
      }
      this.configurationsUpdated = true
    },

    handleChangeAggregateDays(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ aggregateDays: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluateDaysPersistenceAlert(value)
    },
    evaluateDaysPersistenceAlert(value) {
      if (typeof value === 'number' && value >= 0 && value <= 30) {
        this.isDaysPersistenceAlertActive = false
        this.isDaysPersistenceNotificationActive = false
      } else {
        this.isDaysPersistenceAlertActive = true
      }
    },

    handleChangeAggregateReports(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ aggregateReports: value })
      this.activateEnabled = this.getActivateStatus()
      this.evaluateReportPersistenceAlert(value)
    },
    evaluateReportPersistenceAlert(value) {
      if (typeof value === 'number' && value >= 0 && value <= 60) {
        this.isReportPersistenceAlertActive = false
        this.isReportPersistenceNotificationActive = false
      } else {
        this.isReportPersistenceAlertActive = true
      }
    },
    resetTypeAlerts() {
      this.isReportPersistenceAlertActive = false
      this.isReportPersistenceNotificationActive = false
      this.isDaysPersistenceAlertActive = false
      this.isDaysPersistenceNotificationActive = false
      this.isFlightsPersistenceAlertActive = false
      this.isFlightsPersistenceNotificationActive = false
    },
    handleChangeConfigurationType(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        configurationType: value,
        persistenceFrom: value === 'persistence' ? 1 : null,
        persistenceTo: value === 'persistence' ? 1 : null,
        aggregateDays: value === 'aggregateDays' ? 1 : null,
        aggregateReports: value === 'aggregateReports' ? 1 : null,
        validLogic: false,
      })
      this.resetTypeAlerts()
      this.activateEnabled = this.getActivateStatus()
      if (this.customAlert.isEnabled) {
        this.handleToggleActivate(false)
      }
    },

    handleChangeSeverityLevel(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ severityLevel: value })
      this.activateEnabled = this.getActivateStatus()
    },

    handleLaunchRemoveParameterDialog() {
      this.showParameterRemovalConfirmationDialog = true
    },

    handleLaunchCancelDialog() {
      this.isCancelHeader = true
      this.showCancelDialog = true
      this.togglingActive = false
    },

    handleCloseCancelDialog() {
      this.showCancelDialog = false
    },

    handleExitAndSave() {
      this.showCancelDialog = false
      if (this.isConfirmationRequired) {
        this.showVersionChangeConfirmationDialog = true
      } else {
        this.handleExitAndSaveAlert()
      }
    },
    async handleExitAndSaveAlert() {
      this.saveLoading = true
      await this[CAC.SAVE_CUSTOM_ALERT]()
      this.saveLoading = false
      // router push back to custom alerts
      this[CAC.RESET_CURRENT_CUSTOM_ALERT]()
      this.$router.push('/custom-analytics').catch(err => {
        throw new Error(`Problem navigating: ${err}.`)
      })
    },

    handleExitWithoutSaving() {
      this.showCancelDialog = false
      // router push back to custom
      this[CAC.RESET_CURRENT_CUSTOM_ALERT]()
      this.$router.push('/custom-analytics').catch(err => {
        throw new Error(`Problem navigating: ${err}.`)
      })
    },

    handleVersionChangeCancelation() {
      if (this.togglingActive) {
        this.handleToggleActivate(!this.togglingActiveValue)
        this.resetTogglingActive()
      }
      this.onVersionChangeCloseDialog()
    },
    handleVersionChangeConfirmation() {
      if (this.isCancelHeader) {
        this.handleExitAndSaveAlert()
      } else if (this.togglingActive) {
        this.handleToggleActivate(this.togglingActiveValue, true)
        this.resetTogglingActive()
      } else {
        this.handleSave()
        this.handleSaveAlert()
      }
      this.onVersionChangeCloseDialog()
    },
    onVersionChangeCloseDialog() {
      this.showVersionChangeConfirmationDialog = false
      if (this.togglingActive) {
        this.handleToggleActivate(!this.togglingActiveValue)
        this.resetTogglingActive()
      }
    },
    resetTogglingActive() {
      this.togglingActive = false
      this.togglingActiveValue = null
    },

    async handleDuplicateAlert() {
      this.isAlertLoading = true
      await this[CAC.DUPLICATE_CURRENT_ALERT]()
      const newAlertId = this.customAlert.id
      const alertType =
        this.customAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
          ? 'fullflight'
          : 'acmf'
      // need to redirect the user to the new alert
      this.$router
        .push({
          name: 'Custom Analytic',
          params: {
            alertType: alertType,
            alertId: newAlertId,
            isADuplicate: true,
          },
        })
        .catch(err => {
          throw new Error(`Problem navigating: ${err}.`)
        })
    },

    handleCloseDuplicateConfirmationToast() {
      this.showDuplicateConfirmationToast = false
    },

    handleCloseLogicValidatedToast() {
      this.showLogicValidatedToast = false
    },

    handleSeeEstimateToast() {
      this.handleClosePerformanceAnalysisValidatedToast()
      this.handleSeeEstimateDash()
    },

    async handleSeeEstimateDash() {
      this.showSeeEstimateDialog = true
      this.plotlyData = await this.getPlotly(this.customAlert)
    },

    handleSeeEstimateClose() {
      this.showSeeEstimateDialog = false
    },

    handleConfirmRemoveParameter() {
      this.showParameterRemovalConfirmationDialog = false
      this.showConfiguration = false
      this.showAddParameter = true
      this.selectedParameterId = null
      this.selectedParameterName = null
      this.selectedAirline = null
      this.selectedAirlineName = null
      this[CAC.UPDATE_CUSTOM_ALERT]({
        acmfReportNumberId: null,
        airlineId: this.selectedAirline,
        customAlertTypeId: this.customAlert.customAlertTypeId,
        parameterRawName: null,
        parameterId: this.selectedParameterId,
        parameterName: this.selectedParameterName,
        flightPhase: null,
        name: this.customAlert.name,
        persistenceFrom: 1,
        persistenceTo: 1,
        tails: undefined,
        lowCaution: null,
        isHighCautionEnabled: null,
        isHighWarningEnabled: null,
        isLowCautionEnabled: null,
        isLowWarningEnabled: null,
        isRangeMaxEnabled: null,
        isRangeMinEnabled: null,
        lowWarning: null,
        minRange: null,
        maxRange: null,
        highCaution: null,
        highWarning: null,
      })
    },

    cancelRemoveParameter() {
      this.showParameterRemovalConfirmationDialog = false
    },

    handleCloseParameterDialog() {
      this.showParameterDialog = false
    },

    handleUpdateHighCaution(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        highCaution: value.value,
        isHighCautionEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
      this.deactivateToggleStatus()
    },

    handleUpdateLowCaution(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        lowCaution: value.value,
        isLowCautionEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
      this.deactivateToggleStatus()
    },

    handleUpdateLowWarning(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        lowWarning: value.value,
        isLowWarningEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
      this.deactivateToggleStatus()
    },

    handleUpdateHighWarning(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        highWarning: value.value,
        isHighWarningEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
      this.deactivateToggleStatus()
    },

    handleUpdateMinRange(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        minRange: value.value,
        isRangeMinEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
    },

    handleUpdateMaxRange(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({
        maxRange: value.value,
        isRangeMaxEnabled: value.active,
      })
      this.activateEnabled = this.calculateActivateEnabled({
        ...this.customAlert,
        alertType: this.alertType,
      })
    },

    handleToggleActivate(value, saveChanges) {
      this.saveDisabled = false
      this.isCancelHeader = false
      this[CAC.UPDATE_CUSTOM_ALERT]({
        isEnabled: value,
      })
      if (
        this.isConfirmationRequired &&
        saveChanges === true &&
        !this.togglingActive
      ) {
        this.evaluateAllAlerts()
        if (this.areAnyAlertsActive()) {
          this.setNotificationStatuses()
        } else {
          this.togglingActive = true
          this.togglingActiveValue = value
          this.showVersionChangeConfirmationDialog = true
        }
      } else {
        if (saveChanges === true) {
          this.handleSaveAlert()
        }
      }
    },

    async handleAddParameterToCustomAlert(parameterInfo) {
      this.selectedAirline = parameterInfo.airlineId
      this.selectedParameterId = parameterInfo.dataElementId
      this.selectedParameterName = parameterInfo.dataElementName
      this.selectedParameterUnit = parameterInfo.unit
      this.selectedAirlineName = parameterInfo.airlineName
      this.showParameterDialog = false
      this.showConfiguration = true
      this.showAddParameter = false
      this.selectedSimplePlatformId =
        this.mappedAirlineMasterModelAgreement.find(
          masterModel => masterModel.text === parameterInfo.platformName,
        ).value
      this[CAC.UPDATE_CUSTOM_ALERT]({
        airlineId: this.tryParseIntToStringIfNan(this.selectedAirline),
        parameterId: this.selectedParameterId,
        parameterName: this.selectedParameterName,
        parameterRawName: parameterInfo.dataElementRawName,
        parameterUnitName: parameterInfo.unit,
      })
      // need to update the tail dropdown here
      await this.getTailListForParameter()
      if (
        this.customAlert.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID
      ) {
        // for fullflight alerts, get the flight phase list
        await this.getFlightPhaseList()
        // for new alerts, flight phase gets set to all
        if (!this.alertId || this.customAlert.flightPhase === null) {
          const flightPhases = this.mappedFlightPhases.map(flightPhaseObj => {
            return flightPhaseObj.value
          })
          this[CAC.UPDATE_CUSTOM_ALERT]({ flightPhase: flightPhases })
        }
      }
      // for new acmf alerts OR if the alert has been saved but flight phase is null (meaning it was never set), all tails are
      const selectedTails = this.parameterTailList.map(parameterTailListObj => {
        return parameterTailListObj.value
      })
      this[CAC.UPDATE_CUSTOM_ALERT]({ tails: selectedTails })
      await this.loadHistogramData()
    },

    getElementOffset(element) {
      const rect = element.getBoundingClientRect()
      const scrollTop = this.parentElement.scrollTop
      const scrollLeft = this.parentElement.scrollLeft
      const clientTop = this.parentElement.clientTop || 0
      const clientLeft = this.parentElement.clientLeft || 0

      return {
        top: rect.top + scrollTop - clientTop,
        left: rect.left + scrollLeft - clientLeft,
        width: rect.width,
        height: rect.height,
      }
    },

    handlePageScroll() {
      if (!this.isAlertLoading) {
        const wrapperElement = document.querySelector('#asc-content-wrapper')
        const scrollTop = wrapperElement.scrollTop
        const elementOffset = this.getElementOffset(this.$el)
        const offsetDifference = elementOffset.top + 1

        if (offsetDifference <= scrollTop && !this.isSticky) {
          this.isSticky = true
        } else if (offsetDifference > scrollTop && this.isSticky) {
          this.isSticky = false
        }
      }
    },

    handlePageResize() {
      this.isSticky = false
      this.$nextTick(() => {
        this.handlePageScroll()
      })
    },

    logicValidationErrorClose() {
      this.showLogicValidationErrorMessage = false
    },

    getActivateStatus() {
      return this.alertType.includes('advanced')
        ? this.calculateActivateEnabledAdvanced({
            ...this.customAlert,
            alertType: this.alertType,
          })
        : this.calculateActivateEnabled({
            ...this.customAlert,
            alertType: this.alertType,
          })
    },

    async loadAdvancedAlertTypeBasedFields() {
      if (this.isAdvancedAcmf) {
        const reportNumber = this.reportType
          ? this.reportType.split(' - ')[0].trim()
          : ''
        const parameterListData = {
          reportType: this.reportNumberId,
          airlineId: this.airlineId,
        }
        // It can be pushed into one promise if there is no dependency
        await this.getTailListForAdvancedAlert(reportNumber)
        await this.getSnapshotParameterListForModal(parameterListData)
      } else {
        const tailsByPlatformAndAirline = this.getTailsByPlatformAndAirline()
        // It can be pushed into one promise if there is no dependency
        await this[CAC.GET_PART_NUMBERS]({
          platformId: this.platformId,
          airlineId: this.airlineId,
        })
        await this.getTailListForAdvancedAlert(null, tailsByPlatformAndAirline)
        await this.getFlightPhaseList()

        if (this.isAdvancedFullFlight) {
          await this.getFullFlightParameterListForModal(
            this.airlineId,
            this.platformId,
          )
          await this.getDerivedParametersList(this.airlineId, this.platformId)
          await this[CAC.GET_LOOKBACK_RUNCOUNT](this.airlineId)
        } else if (this.isAdvancedDplf) await this.getAllMessageCodes()
      }
    },

    deactivateToggleStatus() {
      if (this.getIsActive && !this.activateEnabled)
        this.handleToggleActivate(this.activateEnabled)
    },

    async loadPerformanceData() {
      await this[CAC.GET_CUSTOM_ALERT_PERFORMANCE]()
    },

    handleChangeResetPerformanceValues(value) {
      this[CAC.UPDATE_CUSTOM_ALERT]({ resetPerformanceValues: value })
      this.activateEnabled = this.getActivateStatus()
    },
    evaluateThresholdAlert() {
      if (
        this.customAlert.isHighCautionEnabled ||
        this.customAlert.isHighWarningEnabled ||
        this.customAlert.isLowWarningEnabled ||
        this.customAlert.isLowCautionEnabled
      ) {
        this.isThresholdAlertActive = false
        this.isThresholdNotificationActive = false
      } else {
        this.isThresholdAlertActive = true
      }
    },
    evaluateFlightPhaseAlert(value) {
      if (value.length === 0) {
        this.isFlightPhaseAlertActive = true
        this.handleChangeSaveDisabled(false)
      } else {
        this.isFlightPhaseAlertActive = false
        this.isFlightPhaseNotificationActive = false
      }
    },
  },
}
</script>

<style lang="scss">
.link-color {
  color: $accent-700 !important;
}

.asc-custom-alerts-alert-container {
  background-color: $gray-100;

  .sticky-header {
    height: 58px;
  }

  .logic-validation-error-wrapper {
    margin-bottom: 20px;
  }
}
</style>
